<template>
  <div>
    <base-nav v-model="showMenu" type="white" :transparent="true" menu-classes="justify-content-end" class="auth-navbar fixed-top">
      <div slot="brand" class="navbar-wrapper">
        <a v-if="title" class="navbar-brand" href="https://jit.cr/register" target="_blank">
          <img src="https://raw.githubusercontent.com/cachac/webAssets/main/logos/jit-basic.png" alt="app-logo" width="20px" />
        </a>
      </div>

      <ul class="navbar-nav">
        <li v-if="page === 'register___en'" href="/" class="nav-link custom-link" @click="gotoLogin()"><i class="tim-icons icon-atom"></i> Login</li>

        <nuxt-link v-else class="nav-item custom-link" tag="li" to="/dashboard">
          <li href="/" class="nav-link"><i class="tim-icons icon-minimal-left"></i> Salir</li>
        </nuxt-link>
      </ul>
    </base-nav>

    <div class="wrapper wrapper-full-page">
      <notifications></notifications>

      <div class="full-page" :class="pageClass">
        <div class="content pt-5">
          <zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
            <nuxt></nuxt>
          </zoom-center-transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ZoomCenterTransition } from 'vue2-transitions'
import { BaseNav } from '@/components'

export default {
  components: {
    BaseNav,
    ZoomCenterTransition
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'black'
    }
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: 'login-page',
      onLine: null
    }
  },
  computed: {
    title() {
      return 'JIT: Restaurantes'
    },
    page() {
      return this.$route.name
    }
  },
  beforeDestroy() {
    this.closeMenu()
  },
  methods: {
    closeMenu() {
      document.body.classList.remove('nav-open')
      this.showMenu = false
    },
    gotoLogin() {
      localStorage.setItem('sf-session-first', 'nuevo ingreso')
      console.log('goto😃')
      this.$router.push('/')
    }
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu()
      setTimeout(() => {
        next()
      }, this.menuTransitionDuration)
    } else {
      next()
    }
  }
}
</script>
<style lang="scss">
.back {
  z-index: 1 !important;
}
.navbar.auth-navbar {
  top: 0;
}

$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}

.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}

.custom-link {
  // color: white;
  font-size: 18px;
  cursor: pointer;
  font-weight: 500;
}
</style>
